document.addEventListener("DOMContentLoaded", function () {
  // Storefront API URL and access token
  const apiUrl = 'https://carpient.myshopify.com/api/2023-07/graphql.json';
  const accessToken = '610fc710bbebc9a5f0061f25504283a2'; // Your Storefront API access token

  // Cache duration: 7 days in milliseconds
  const CACHE_DURATION = 7 * 24 * 60 * 60 * 1000;

  // Define supported languages globally
  const supportedLanguages = ['en', 'fr', 'de', 'es', 'it', 'pt', 'sv', 'fi', 'nl', 'hu', 'pl', 'da']; // Added 'sv'


  // Function to get the current language prefix from the URL
  const getLanguagePrefix = () => {
    const pathSegments = window.location.pathname.split('/');
    // Assuming the first segment after the initial '/' is the language code
    // e.g., '/sv/products/handle' -> 'sv'
    if (pathSegments.length > 2) { // ['', 'sv', 'products', 'handle']
      const possibleLang = pathSegments[1];
      if (supportedLanguages.includes(possibleLang)) {
        return `/${possibleLang}`;
      }
    }
    return ''; // Default language, no prefix
  };

  // Get the language prefix
  const languagePrefix = getLanguagePrefix();

  // Get current product handle from the URL
  // This assumes that the product handle is always the last segment in the URL
  const currentProductHandle = window.location.pathname
    .split("/")
    .filter(segment => segment !== '' && !supportedLanguages.includes(segment))
    .pop();

  // Metafield namespaces
  const metafieldNamespaces = {
    custom: 'custom',
    magento: 'magento'
  };

  // Function to show the loader and hide content
  const showLoader = () => {
    const loader = document.getElementById('loader');
    const content = document.querySelector('.content');
    if (loader) loader.style.display = 'block';
    if (content) content.style.display = 'none';
  };

  // Function to hide the loader and show content
  const hideLoader = () => {
    const loader = document.getElementById('loader');
    const content = document.querySelector('.content');
    if (loader) loader.style.display = 'none';
    if (content) content.style.display = 'block';
  };

  // Show loader initially
  showLoader();

  // Helper function to get the cached color swatches if they exist and are still valid
  const getCachedColorSwatches = (productHandle) => {
    const cachedData = JSON.parse(localStorage.getItem('colorSwatchesCache'));
    if (cachedData && cachedData[productHandle]) {
      const { timestamp, data } = cachedData[productHandle];
      const now = Date.now();

      // Check if the cached data is still valid (within 7 days)
      if (now - timestamp < CACHE_DURATION) {
        return data; // Return cached data if it's still valid
      }
    }
    return null; // Return null if no valid cache exists
  };

  // Helper function to cache color swatches
  const cacheColorSwatches = (productHandle, swatches) => {
    const cachedData = JSON.parse(localStorage.getItem('colorSwatchesCache')) || {};
    cachedData[productHandle] = {
      timestamp: Date.now(),
      data: swatches
    };
    localStorage.setItem('colorSwatchesCache', JSON.stringify(cachedData));
  };

  // Function to fetch the current product's data
  const fetchCurrentProduct = () => {
    const query = `
      {
        productByHandle(handle: "${currentProductHandle}") {
          id
          title
          handle
          featuredImage {
            url
            altText
          }
          variants(first: 1) {
            edges {
              node {
                sku
              }
            }
          }
          metafields(identifiers: [
            {namespace: "${metafieldNamespaces.custom}", key: "designid"},
            {namespace: "${metafieldNamespaces.magento}", key: "shape"},
            {namespace: "${metafieldNamespaces.magento}", key: "size_group"},
            {namespace: "${metafieldNamespaces.magento}", key: "color"}
          ]) {
            namespace
            key
            value
          }
          collections(first: 5) {
            edges {
              node {
                id
                handle
                title
              }
            }
          }
        }
      }
    `;

    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken
      },
      body: JSON.stringify({ query })
    })
    .then(response => response.json())
    .then(data => {
      if (data.errors) {
        console.error('GraphQL errors:', data.errors);
        return null;
      }
      return data.data.productByHandle;
    })
    .catch(error => {
      console.error('Error fetching product data:', error);
      return null;
    });
  };

  // Function to fetch products by collection
  const fetchProductsByCollection = (collectionId) => {
    const query = `
      {
        collection(id: "${collectionId}") {
          products(first: 250) {
            edges {
              node {
                id
                title
                handle
                featuredImage {
                  url
                  altText
                }
                variants(first: 1) {
                  edges {
                    node {
                      sku
                    }
                  }
                }
                metafields(identifiers: [
                  {namespace: "${metafieldNamespaces.custom}", key: "designid"},
                  {namespace: "${metafieldNamespaces.magento}", key: "shape"},
                  {namespace: "${metafieldNamespaces.magento}", key: "size_group"},
                  {namespace: "${metafieldNamespaces.magento}", key: "color"}
                ]) {
                  namespace
                  key
                  value
                }
              }
            }
          }
        }
      }
    `;

    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken
      },
      body: JSON.stringify({ query })
    })
    .then(response => response.json())
    .then(data => {
      if (data.errors) {
        console.error('GraphQL errors:', data.errors);
        return [];
      }
      return data.data.collection.products.edges.map(edge => edge.node);
    })
    .catch(error => {
      console.error('Error fetching products by collection:', error);
      return [];
    });
  };

  // Main function to execute
  const main = async () => {
    // Always render the size options, even when using cached swatches
    const renderSizeOptionsAlways = true;

    // Check if color swatches are cached and load them if available
    const cachedSwatches = getCachedColorSwatches(currentProductHandle);
    if (cachedSwatches && !renderSizeOptionsAlways) {
      console.log('Using cached swatches:', cachedSwatches);
      renderSwatches(cachedSwatches);
      hideLoader();
      return;
    }

    // Fetch the current product
    const product = await fetchCurrentProduct();

    if (!product) {
      console.error('Product not found');
      hideLoader();
      return;
    }

    // Extract the metafields of the current product
    const metafields = {};
    product.metafields.forEach(mf => {
      if (mf) {
        metafields[`${mf.namespace}.${mf.key}`] = mf.value;
      }
    });

    const currentProductDesignId = metafields['custom.designid'];
    const currentProductShape = metafields['magento.shape'];
    const currentProductSizeGroup = metafields['magento.size_group'];
    const currentProductColor = metafields['magento.color'];

    // Log the current product's metafields
    console.log('Current Product custom.designid:', currentProductDesignId);
    console.log('Current Product magento.shape:', currentProductShape);
    console.log('Current Product magento.size_group:', currentProductSizeGroup);
    console.log('Current Product magento.color:', currentProductColor);

    // Check that all required metafields are available
    if (!currentProductDesignId || !currentProductShape || !currentProductSizeGroup) {
      console.error('Required metafields not found on current product');
      hideLoader();
      return;
    }

    // Extract the prefix from the custom.designid (everything before "_")
    const designIdPrefix = currentProductDesignId.split('_')[0];

    if (!designIdPrefix) {
      console.error('Design ID prefix not found');
      hideLoader();
      return;
    }

    // Fetch other products in the same collections
    const collectionEdges = product.collections.edges;
    const collectionIds = collectionEdges.map(edge => edge.node.id);
    const uniqueCollectionIds = [...new Set(collectionIds)];

    // Fetch products from each collection
    const productPromises = uniqueCollectionIds.map(collectionId => fetchProductsByCollection(collectionId));

    // Wait for all products to be fetched
    const collectionProductsArray = await Promise.all(productPromises);

    // Flatten the array
    const allProducts = collectionProductsArray.flat();

    // Initialize data structures
    const colorProducts = {}; // Map to store products by color with the same size
    const swatchesToCache = []; // To store the swatches for caching
    const sizes = new Set(); // To store unique sizes
    const sizeUrlMap = {}; // Map sizes to product URLs

    // Process all products to collect sizes and colors
    allProducts.forEach(prod => {
      const prodMetafields = {};
      prod.metafields.forEach(mf => {
        if (mf) {
          prodMetafields[`${mf.namespace}.${mf.key}`] = mf.value;
        }
      });

      const designId = prodMetafields['custom.designid'];
      const productShape = prodMetafields['magento.shape'];
      const productSizeGroup = prodMetafields['magento.size_group'];
      const color = prodMetafields['magento.color'];

      const designIdProductPrefix = designId ? designId.split('_')[0] : null;

      const productUrl = `${languagePrefix}/products/${prod.handle}`; // Updated to include language prefix

      // Collect sizes for all products with the same designId (ignoring the shape)
      if (designIdProductPrefix && designIdProductPrefix === designIdPrefix) {
        const size = productSizeGroup;
        sizes.add(size);
        if (!sizeUrlMap[size]) {
          sizeUrlMap[size] = productUrl;
        }
      }


      // Collect colors for products with the same designId prefix, same shape, same size, and different colors
      if (
        designIdProductPrefix &&
        designIdProductPrefix === designIdPrefix &&
        productShape &&
        productShape === currentProductShape &&
        productSizeGroup &&
        productSizeGroup === currentProductSizeGroup
      ) {
        if (color && !colorProducts[color]) {
          colorProducts[color] = prod;

          // Create swatch data
          if (prod.featuredImage && prod.featuredImage.url) {
            const swatchData = {
              url: `${languagePrefix}/products/${prod.handle}`, // Updated to include language prefix
              image: prod.featuredImage.url,
              altText: prod.featuredImage.altText || prod.title,
              color: color,
              handle: prod.handle // Added handle for identifying current product
            };
            swatchesToCache.push(swatchData);
          }
        }
      }
    });

    // Cache the swatches for 7 days
    cacheColorSwatches(currentProductHandle, swatchesToCache);

    // Render the swatches
    renderSwatches(swatchesToCache);

    // Render the size buttons
    renderSizeButtons(sizes, sizeUrlMap, currentProductSizeGroup);

    // Hide loader after processing data
    hideLoader();
  };

  // Helper function to render swatches
  const renderSwatches = (swatches) => {
    const container = document.querySelector('.product-list-container');
    if (!container) {
      console.error('Swatch container not found');
      return;
    }
    container.innerHTML = ''; // Clear the container before appending

    swatches.forEach(swatch => {
      const linkElement = document.createElement('a');
      linkElement.href = swatch.url;
      linkElement.classList.add('swatch-link');

      // If this swatch corresponds to the current product, add 'active' class
      if (swatch.handle === currentProductHandle) {
        linkElement.classList.add('active');
      }

      const imgElement = document.createElement('img');
      imgElement.src = swatch.image;
      imgElement.alt = swatch.altText;
      imgElement.style.maxWidth = '75px';
      imgElement.style.maxHeight = '75px';

      linkElement.appendChild(imgElement);
      container.appendChild(linkElement);

      // Add event listener to handle click
      linkElement.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent default link behavior

        // Remove active class from all swatch links
        document.querySelectorAll('.product-list-container .swatch-link').forEach(link => link.classList.remove('active'));

        // Add active class to the clicked swatch
        this.classList.add('active');

        // Redirect to the clicked product while preserving the language
        window.location.href = swatch.url;
      });
    });
  };

  // Additional DOMContentLoaded listener to handle swatch border styling
  // Ensure this runs after the main DOMContentLoaded
  const handleSwatchBorder = () => {
    const container = document.querySelector('.product-list-container'); 
    if (!container) return; 

    const swatchLink = container.querySelector('.swatch-link.active'); 
    if (!swatchLink) return; 

    const image = swatchLink.querySelector('img'); 
    if (!image) return; // Exit if image is not found

    // Function to show the border when image loads
    const showBorder = function() {
      swatchLink.style.borderColor = '#000'; // Change border color to black
      swatchLink.style.borderWidth = '2px'; // Add border width for visibility
      swatchLink.style.borderStyle = 'solid'; // Ensure border is visible
    };

    // If the image is already loaded
    if (image.complete) {
      showBorder();
    } else {
      // When the image loads
      image.addEventListener('load', showBorder);
    }
  };

  document.addEventListener('DOMContentLoaded', handleSwatchBorder);

  // Helper function to render the size buttons
 // Helper function to render the size buttons
const renderSizeButtons = (sizes, sizeUrlMap, currentProductSizeGroup) => {
  const sizeDropdownContainer = document.querySelector('.size-dropdown-container');
  if (!sizeDropdownContainer) {
    console.error('Size dropdown container not found');
    return;
  }
  sizeDropdownContainer.innerHTML = ''; // Clear existing content

  if (sizes.size > 0) {
    const buttonContainer = document.createElement('div');
    buttonContainer.id = 'size-select'; 

    // Sort sizes for consistent order
    const sortedSizes = Array.from(sizes).sort();

    sortedSizes.forEach(size => {
      // Split the size by 'x' to get width and length
      const [width, length] = size.split('x');

      // Determine if we should show "∅ width" if width and length are equal
      const displaySize = (width === length) ? `∅ ${width}` : size;

      const buttonElement = document.createElement('button');
      buttonElement.classList.add('option');
      buttonElement.value = size;
      buttonElement.textContent = displaySize;

      // If this size is the current product's size, add 'active' class
      if (size === currentProductSizeGroup) {
        buttonElement.classList.add('active');
      }

      // Add event listener to handle click
      buttonElement.addEventListener('click', function () {
        // Remove active class from all buttons
        const allButtons = document.querySelectorAll('#size-select .option');
        allButtons.forEach(btn => btn.classList.remove('active'));

        // Add active class to the clicked button
        this.classList.add('active');

        const selectedSize = this.value;
        // Redirect to the correct URL based on the selected size while preserving the language
        if (selectedSize && sizeUrlMap[selectedSize]) {
          window.location.href = sizeUrlMap[selectedSize];
        }
      });

      buttonContainer.appendChild(buttonElement);
    });

    // Append the button container to the size dropdown container
    sizeDropdownContainer.appendChild(buttonContainer);
  } else {
    const noSizeElement = document.createElement('p');
    noSizeElement.textContent = 'No available sizes';
    sizeDropdownContainer.appendChild(noSizeElement);
  }
};


  // Execute the main function
  main();
});
